(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-app-story]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.classList.add('ias--js');

      // Accordion: one open step at a time
      root.querySelectorAll('[data-step]').forEach(step => {
        const toggle = step.querySelector('[data-step-toggle]');
        toggle.addEventListener('click', () => {
          root.querySelectorAll('[data-step]').forEach(other => {
            const open = other === step;
            other.classList.toggle('is-open', open);
            other.querySelector('[data-step-toggle]').setAttribute('aria-expanded', String(open));
          });
        });
      });

      // Tabs with arrow-key support
      root.querySelectorAll('[data-tabs]').forEach(tabs => {
        const buttons = [...tabs.querySelectorAll('[data-tab]')];
        const panels = [...tabs.querySelectorAll('[data-panel]')];
        const select = (index, focus) => {
          buttons.forEach((button, i) => {
            const on = i === index;
            button.setAttribute('aria-selected', String(on));
            button.tabIndex = on ? 0 : -1;
            panels[i].hidden = !on;
          });
          if (focus) buttons[index].focus();
          buttons[index].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
        };
        buttons.forEach((button, i) => {
          button.addEventListener('click', () => select(i, false));
          button.addEventListener('keydown', event => {
            const last = buttons.length - 1;
            const keys = { ArrowRight: (i + 1) > last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last };
            if (event.key in keys) { event.preventDefault(); select(keys[event.key], true); }
          });
        });
      });

      // Reveal on scroll
      const items = [...root.querySelectorAll('[data-reveal]')];
      if ('IntersectionObserver' in window && !reduce) {
        const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); reveal.unobserve(entry.target); }
        }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        items.forEach(item => reveal.observe(item));
      } else {
        items.forEach(item => item.classList.add('is-in'));
      }

      // Videos load and play only when visible; stay still for reduced motion
      const videos = [...root.querySelectorAll('[data-lazy-video]')];
      if (!reduce && 'IntersectionObserver' in window) {
        const play = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); });
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }), { threshold: 0.25 });
        videos.forEach(video => play.observe(video));
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
